import { render, staticRenderFns } from "./BodyRegions.vue?vue&type=template&id=ffa753be&scoped=true"
import script from "./BodyRegions.vue?vue&type=script&lang=js"
export * from "./BodyRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa753be",
  null
  
)

export default component.exports